import { useSearchParams } from 'react-router-dom';
import MFCRedirectionAutoPage from './MFCRedirectionAutoPage'
import MFCRedirectionQRPage from './MFCRedirectionQRPage'

enum RedirectionType {
    QR = 'qr',
    AUTO = 'auto',
}

export default function MFCRedirectionPage() {
    const [searchParams] = useSearchParams();
    const redirectionType = searchParams?.get('redirectionType') ?? '';
    if (redirectionType === RedirectionType.QR) {
        return <MFCRedirectionQRPage />
    }
    if (redirectionType === RedirectionType.AUTO) {
        return <MFCRedirectionAutoPage />
    }
    return <MFCRedirectionQRPage />
}
